import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectSiretSearchRetrieval = createSelector(
  [(state: AppState) => state.shared.siretSearchRetrieval],
  ({ data, fetching }) => ({ data, fetching }),
);
